module.exports = __webpack_public_path__ + "static/img/bg-highlights-4.7785df49.png";